import React, { FC, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
  show: boolean;
  onClose: () => void;
  userNameWithError: string | null;
}

const ToastMessage: FC<IProps> = ({ show, onClose, userNameWithError }: IProps) => {
  const { t } = useTranslation();
  const [percentageLeft, setPercentageLeft] = useState(100);

  const timerRef = useRef<any | null>(null);
  const intervalRef = useRef<any | null>(null);
  const showRef = useRef(show); // Reference to track the previous value of 'show' prop

  useEffect(() => {
    // Only start the timer and interval if 'show' changes from false to true
    if (show && !showRef.current) {
      setPercentageLeft(98);
      timerRef.current = setTimeout(() => {
        onClose();
        timerRef.current = null;
      }, 5000);

      intervalRef.current = setInterval(() => {
        setPercentageLeft(prev => Math.max(prev - 1, 0));
      }, 50);
    }

    // Clear the timer and interval if 'show' changes from true to false
    if (!show && showRef.current) {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }

    // Update the 'showRef' to the latest value of 'show' prop at the end of the effect
    showRef.current = show;
  }, [show, onClose]);

  return (
    <div
      style={{
        position: 'fixed',
        top: 80,
        right: 20,
        zIndex: 9999,
        opacity: show ? 1 : 0,
        transition: 'opacity 1s',
        pointerEvents: show ? 'auto' : 'none',
      }}
    >
      {show && (
        <div style={{ padding: '10px 20px', background: '#ef476f', color: 'white', borderRadius: 5 }}>
          <span>{t('docWizard.step3.userError', { user: userNameWithError })}</span>
          <button
            type="button"
            onClick={onClose}
            style={{ marginLeft: 20, background: 'transparent', border: 'none', color: 'white' }}
          >
            X
          </button>
          <div style={{ height: '5px', borderRadius: '3px', marginTop: '10px' }}>
            <div
              style={{
                height: '100%',
                width: `${percentageLeft}%`,
                backgroundColor: 'white',
                transition: 'width 0.1s',
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ToastMessage;
